module.exports = __webpack_public_path__ + "img/lat_logo.ed1794b7.png";